import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';

/**
 * Custom vehicle icon for the last position in track mode
 */
const createVehicleIcon = () => {
  return L.divIcon({
    className: 'custom-vehicle-marker',
    html: `
      <div style="
        width: 40px;
        height: 40px;
        background-color: #007bff;
        border: 3px solid #ffffff;
        border-radius: 50%;
        box-shadow: 0 3px 8px rgba(0,0,0,0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
      ">
        🚐
      </div>
    `,
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    tooltipAnchor: [0, -20]
  });
};

/**
 * VehicleMarker component - Shows vehicle icon at the last known position
 * @param {Object} props
 * @param {Object} props.position - Position { latitude, longitude, timestamp }
 * @param {Object} props.rondaInfo - Ronda information
 * @param {Function} props.onClick - Click handler
 */
const VehicleMarker = ({ position, rondaInfo, onClick }) => {
  if (!position || !position.latitude || !position.longitude) {
    return null;
  }

  const icon = createVehicleIcon();

  const formatTime = (timestamp) => {
    if (!timestamp) return 'Desconhecido';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('pt-PT', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleClick = () => {
    if (onClick) {
      // Se onClick for uma função, chamá-la diretamente (para reiniciar animação)
      if (typeof onClick === 'function') {
        onClick();
      } else {
        // Caso contrário, chamar com os dados (comportamento antigo)
        onClick({ position, rondaInfo });
      }
    }
  };

  return (
    <Marker
      position={[position.latitude, position.longitude]}
      icon={icon}
      eventHandlers={{
        click: handleClick
      }}
    >
      <Tooltip permanent direction="top" offset={[0, -20]}>
        <div style={{ textAlign: 'center' }}>
          <strong>{rondaInfo?.nome || rondaInfo?.codigo || 'Ronda'}</strong>
          <br />
          <small style={{ color: '#666' }}>
            {position.local ? (
              <>
                {position.local}
                <br />
                {formatTime(position.timestamp)}
              </>
            ) : (
              formatTime(position.timestamp)
            )}
          </small>
        </div>
      </Tooltip>
    </Marker>
  );
};

export default VehicleMarker;
